export default __webpack_public_path__ + "static/media/O-024.8c8db2f4.png";